"use client"

import React from "react";

type ButtonProps = {
  children?: React.ReactNode;
  type?: "button" | "submit";
  text?: string;
  className?: string;
  disabled?: boolean;
  onClick?: {
    (e: React.MouseEvent<HTMLButtonElement>): void;
  };
  loading?: boolean;
  ariaLabel?: string;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function formButton({ onClick, disabled, loading, children, className, ariaLabel, type }: ButtonProps, ref) {

  if (loading) return <button disabled className={className}>Loading<span className='loadingDots'></span></button>

  return (
    <button
      type={type ? type : "button"}
      ref={ref}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      { children }
    </button>
  )
})